import { render } from "./SubjectAudit.vue?vue&type=template&id=7af94f60&scoped=true"
import script from "./SubjectAudit.vue?vue&type=script&lang=js"
export * from "./SubjectAudit.vue?vue&type=script&lang=js"

import "./SubjectAudit.vue?vue&type=style&index=0&id=7af94f60&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af94f60"]])

export default __exports__